import {html} from 'lit';
import {Service} from '../../service/service.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {TimeUtil} from '../../utils/timeUtil.js';
import {ExportUtil} from '../../utils/exportUtil.js';
import {BaseComponent} from '../basecomponent.js';


/* global customElements */
export class EmailHistoryGrid extends BaseComponent {
	
	static get properties() {
		return {			
		};
	}
	
	constructor() {
		super();
		
		this.local = false;
		
		var emailHistoryGrid = this;
		setTimeout(function(){
			emailHistoryGrid.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>		
		`;
	}
	
	init() {
		var emailHistoryGrid = this;

		var defaultStartDate = function() {
			var startDate = new Date();
			startDate.setDate(startDate.getDate() - 30);
			return TimeUtil.formatDateForTimeField(startDate);
		};

		var defaultEndDate = function() {
			return TimeUtil.formatDateForTimeField(new Date());
		};
		
		var toolbarFilter = ElementUtil.create({
			tag: 'dl-toolbar',
			'collapse-label': 'Filter',
			slot: 'toolbar',
			theme: 'spacing',
			children: [
				{	
					tag: 'vaadin-combo-box',
					itemid: 'sendStatus',						
					'class': 'spacer-toolbar-item',
					'item-value-path': 'code',
					'item-label-path': 'desc',
					'prevent-invalid-input': true,
					label: 'Status',
					clearButtonVisible: true,
					style: 'width: 11em;',
					postinit: function(combo) {							
						combo.items = [
							{ code: '', desc: 'All Statuses' },
							{ code: 'SENT', desc: 'Sent' },
							{ code: 'FAILED_VALIDATION', desc: 'Failed Validation' },
							{ code: 'FAILED_SEND', desc: 'Failed Send' },
							{ code: 'NOT_CONFIGURED', desc: 'Not Configured' }
						];
						combo.value = '';
					},
					listeners: {
						'selected-item-changed': function() {
							if (actionRefresh){
								actionRefresh();
							}
						}
					}					
				},
				{										
					tag: 'vaadin-combo-box',
					itemid: 'filterCompany',
					'class': 'spacer-toolbar-item',
					'keep-open': true,					
					style: 'width: 250px;',
					label: 'Company',
					'item-value-path': 'code',
					'item-label-path': 'description',
					clearButtonVisible: true,
					postinit: function(combo) {
						Service.getCompanyService().getCompaniesLookup().then(function(data){
							var items = data ? data.slice() : [];
							items.unshift({
								code: 'system',
								description: 'System'
							});
							combo.items = items;
						});
					},
					placeHolder: 'Select',
					listeners: {
						change: function() {
							actionRefresh();
						}
					}					
				},
				{										
					tag: 'vaadin-combo-box',
					itemid: 'filterField',
					'class': 'spacer-toolbar-item',
					label: 'Filter By',
					'item-value-path': 'code',
					'item-label-path': 'description',
					style: 'width: 10em;',
					value: 'subject',
					postinit: function(combo) {						
						combo.items = [
							{ code: 'subject', description: 'Subject' },
							{ code: 'recipientSearch', description: 'Recipient' },
							{ code: 'username', description: 'User' }
						];
					}
				},
				{
					tag: 'vaadin-text-field',
					itemid: 'filterValue',
					'class': 'spacer-toolbar-item',
					label: 'Filter Value',
					clearButtonVisible: true,
					style: 'width: 14em;',
					listeners: {
						input: {
							fn: function() {
								actionRefresh();
							},
							buffer: 2000
						},
						change: function() {
							actionRefresh();
						}
					}
				},
				{
					tag: 'vaadin-date-picker',
					'class': 'spacer-toolbar-item',
					itemid: 'filterStartDate',
					label: 'Start Date',
					value: defaultStartDate()
				},
				{
					tag: 'vaadin-date-picker',
					'class': 'spacer-toolbar-item',
					itemid: 'filterEndDate',
					label: 'End Date',
					value: defaultEndDate()
				}
			]
		});
		
		var toolbar = ElementUtil.create({
			tag: 'dl-toolbar',
			slot: 'toolbar',
			theme: 'spacing',
			children: [
				{
					tag: 'vaadin-button',
					itemid: 'refresh',
					'class': 'spacer-toolbar-item',
					children:[
						ElementUtil.makeIcon('vaadin:refresh', ' Refresh')
					], 
					listeners: {
						click: function() {
							actionRefresh();
						}
					}
				},
				{
					tag: 'vaadin-button',
					itemid: 'view',
					theme: 'primary',
					disabled: true,
					'class': 'spacer-toolbar-item',
					children:[
						ElementUtil.makeIcon('lumo:eye', ' View')
					],
					listeners: {
						click: function() {							
							actionView(grid.selectedItems[0]);
						}
					}
				},
				{
					tag: 'vaadin-button',
					itemid: 'download',
					theme: 'contrast primary',
					disabled: true,
					'class': 'spacer-toolbar-item',
					children:[
						ElementUtil.makeIcon('vaadin:download', ' Download Email')
					],
					listeners: {
						click: function() {
							Service.getEmailHistoryService().downloadEmailPackage(grid.selectedItems[0].emailHistoryId);
						}
					}
				}
			]
		});

		var toolbarContainer = ElementUtil.create({
			tag: 'div',
			slot: 'toolbar',
			children: [
				toolbarFilter,
				ElementUtil.create({
					tag: 'hr'
				}),
				toolbar
			]
		});
		
		var grid = ElementUtil.create({
			tag: 'vaadin-grid',
			theme: 'row-stripes column-borders',
			'column-reordering-allowed': '',
			style: 'height: 100%;',
			slot: 'primary',
			defaults: {
				tag: 'vaadin-grid-sort-column',
				resizable: true,
				listeners: {
					'direction-changed' : function(event) {
						if (event.detail && event.detail.value) {
							grid.currentSortField = event.target.path;
							grid.currentSortDirection = event.detail.value.toUpperCase();
							pagingToolbar.loadCurrentPage();
						}
					}
				}
			},			
			children: [	
				{						
					path: 'sentAt',
					header: 'Sent At',					
					width: '9em',
					renderer: function(root, column, rowData) {
						var date = TimeUtil.parseDate(rowData.item.sentAt);						
						root.innerHTML = TimeUtil.formatDateStandard(date);						
					}
				},
				{						
					path: 'companyName',
					header: 'Company',					
					width: '10em'
				},
				{						
					path: 'statusDescription',
					header: 'Status',					
					width: '8em'
				},
				{						
					path: 'subject',
					header: 'Subject',					
					width: '14em'
				},
				{						
					path: 'recipientSearch',
					header: 'Recipients',					
					width: '12em'
				},
				{						
					path: 'failureReason',
					header: 'Failure Reason',					
					width: '14em',
					renderer: function(root, column, rowData) {
						root.innerHTML = rowData.item.failureReason ? rowData.item.failureReason : '';
					}
				},
				{						
					path: 'username',
					header: 'User',					
					width: '7em'
				}
			],
			listeners: {
				'active-item-changed': function(event) {
					const item = event.detail.value;
					grid.selectedItems = item ? [item] : [];
					var hasSelection = grid.selectedItems.length > 0;
					ElementUtil.query(toolbar, 'view').disabled = !hasSelection;
					ElementUtil.query(toolbar, 'download').disabled = !hasSelection;
				}
			}
		});		
		
		var pagingToolbar = ElementUtil.create({
			tag: 'dl-paging-toolbar',
			pageSize: 100,
			postinit: function(element) {
				element.grid = grid;
				element.loader = function(backingGrid, pageNumber, pagingToolbar) {
					var pageRange = pagingToolbar.pullRange();
					var loadMask = grid.showLoading();

					var startFilterDts = TimeUtil.startOfDayCompanyTime(ElementUtil.query(toolbarFilter, 'filterStartDate').value);
					var endFilterDts = TimeUtil.endOfDayCompanyTime(ElementUtil.query(toolbarFilter, 'filterEndDate').value);
					var sendStatus = ElementUtil.query(toolbarFilter, 'sendStatus').value;
					var companyId = ElementUtil.query(toolbarFilter, 'filterCompany').value;
					var filterField = ElementUtil.query(toolbarFilter, 'filterField').value;
					var filterValue = ElementUtil.query(toolbarFilter, 'filterValue').value;
					
					emailHistoryGrid.currentFilter = {
						offset: pageRange.offset,
						max: pageRange.max,
						sortField: backingGrid.currentSortField || 'sentAt',
						sortOrder: backingGrid.currentSortDirection || 'DESC',
						dateField: 'sentAt',
						start: startFilterDts,
						end: endFilterDts
					};

					if (sendStatus) {
						emailHistoryGrid.currentFilter.sendStatus = sendStatus;
					}
					if (companyId) {
						emailHistoryGrid.currentFilter.companyId = companyId;
					}
					if (filterField && filterValue) {
						emailHistoryGrid.currentFilter.filterField = filterField;
						emailHistoryGrid.currentFilter.filterValue = filterValue;
					}
					
					var successHandler = function(records) {
						loadMask.remove();
						grid.activeItem = null;						
						grid.items = records.data;
						
						emailHistoryGrid.fullDataSet = records.data;						
						pagingToolbar.totalRecords = records.totalNumber;
						pagingToolbar.updatePager();						
					};
					
					Service.getEmailHistoryService().getEmailHistory(emailHistoryGrid.currentFilter)
					.then(function(records){							
						successHandler(records);
					});
										
				};
			},
			listeners: {
				ready: function() {					
					pagingToolbar.loadCurrentPage();
				}
			}
			
		});

		var footer = ExportUtil.createExportFooter({
			pagingToolbar: pagingToolbar,
			grid: grid,
			itemid: 'primary',
			onDetail: function() {
				var exportFilter = Object.assign({}, emailHistoryGrid.currentFilter || {});
				delete exportFilter.offset;
				delete exportFilter.max;
				Service.getEmailHistoryService().exportEmailHistory(exportFilter);
			}
		});
		
		var flexLayout = ElementUtil.create({
			tag: 'dl-flex-layout',
			children: [
				toolbarContainer,
				grid,
				footer.footerContainer
			]
		});		
		emailHistoryGrid.append(flexLayout);				
		
		var actionRefresh = function() {
			pagingToolbar.loadPage(1);
		};
		
		var actionView = function(record) {
			var viewWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'View Email History',
				icon: 'lumo:eye',
				listeners: {
					ready: function() {
						
						viewWin.show();
						
						var getDetails = function(inputRecord, messagePayload) {
							var isSuccess = inputRecord.sendStatus === 'SENT';
							var outcomeIcon = isSuccess ? 'vaadin:check-circle-o' : 'vaadin:warning';
							var failureText = inputRecord.failureReason ? inputRecord.failureReason : 'None';
							var failureDisplay = '<vaadin-icon icon="' + outcomeIcon +
								'" style="width:1.1em;height:1.1em;vertical-align:middle;margin-right:0.35em;"></vaadin-icon>' +
								failureText;
							var detailData = [
								{
									key: 'Sent At',
									value: TimeUtil.formatDateStandard(TimeUtil.parseDate(inputRecord.sentAt))
								},
								{
									key: 'Company',
									value: inputRecord.companyName
										? inputRecord.companyName + ' (' + inputRecord.companyId + ')'
										: inputRecord.companyId
								},
								{
									key: 'Status',
									value: inputRecord.statusDescription
										? inputRecord.statusDescription
										: inputRecord.sendStatus
								},
								{
									key: 'Failure Reason',
									value: failureDisplay
								},
								{
									key: 'From',
									value: inputRecord.fromAddress
								},
								{
									key: 'Subject',
									value: inputRecord.subject
								},
								{
									key: 'To',
									value: (inputRecord.toAddresses || []).join(', ')
								},
								{
									key: 'CC',
									value: (inputRecord.ccAddresses || []).join(', ')
								},
								{
									key: 'BCC',
									value: (inputRecord.bccAddresses || []).join(', ')
								},
								{
									key: 'User',
									value: inputRecord.username ? inputRecord.username : 'N/A'
								},
								{
									key: 'Attachments',
									value: (inputRecord.attachmentNames || []).join(', ')
								},
								{
									key: 'Node',
									value: inputRecord.nodeName ? inputRecord.nodeName : 'N/A'
								},
								{
									key: 'Archive Path',
									value: inputRecord.zipRelativePath
								}
							];
							if (messagePayload && messagePayload.messageHTML) {
								detailData.push({
									key: 'Message Body',
									value: '<iframe style="width:100%;height:280px;border:1px solid #ccc;background:#ffffff;" srcdoc="' +
										messagePayload.messageHTML.replace(/"/g, '&quot;') +
										'"></iframe>'
								});
							}
							return detailData;
						};
						
						var details = ElementUtil.create({
							tag: 'dl-flex-layout',
							children: [
								{
									tag: 'div',									
									slot: 'primary',
									children: [
										{
											tag: 'dl-detail-table',
											itemid: 'table',
											style: ''											
										},
										{
											tag: 'vaadin-button',
											itemid: 'downloadDialog',
											theme: 'contrast primary',
											style: 'margin-top: 0.5em;',
											children:[
												ElementUtil.makeIcon('vaadin:download', ' Download Email')
											],
											listeners: {
												click: function() {
													Service.getEmailHistoryService().downloadEmailPackage(record.emailHistoryId);
												}
											}
										}
									]
								},
								{
									tag: 'dl-nextprev-toolbar',	
									itemid: 'nextPrev',
									slot: 'footer',
									listeners: {
										ready: function(event){
											event.target.updateData(emailHistoryGrid.fullDataSet);
											event.target.setSelectedRecord('emailHistoryId', record.emailHistoryId);
										},
										change: function(event) {
											grid.deselectItem(record);
											grid.selectItem(event.detail.item);
											record = event.detail.item;
											loadRecordDetails(record);
										}										
									}
								}
							]
						});

						var loadRecordDetails = function(inputRecord) {
							Service.getEmailHistoryService().getEmailMessage(inputRecord.emailHistoryId)
							.then(function(messagePayload) {
								ElementUtil.query(details, 'table').updateDetails(getDetails(inputRecord, messagePayload));
							})
							.catch(function() {
								ElementUtil.query(details, 'table').updateDetails(getDetails(inputRecord, null));
							});
						};

						loadRecordDetails(record);
						viewWin.addToContentElement(details);
					}
				}
			});
		};
	}
	
}

customElements.define('dl-email-history-grid', EmailHistoryGrid);
